export default __webpack_public_path__ + "36b9330dbb91ace6e5cd8113459de222.png";